<template>
    <div class="map" :id="initId">
        <div class="loction center">
            x：{{mouseLng}}y：{{mouseLat}}
        </div>
        <div class="changeMap">
            <el-select class="xixi" v-model="value" @change="changeValue" placeholder="请选择" size="mini">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.fileCreateTime"
                :value="item.fileName">
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
import 'leaflet/dist/leaflet.css'
// import axios from '@/utils/axios.min'
import L from 'leaflet'
import {tiledMapLayer} from '@supermap/iclient-leaflet'
import {getImageShowList} from "@/api/product/index"
import {tiandituTileLayer} from '@supermap/iclient-leaflet';
export default {
    props:{
        initId:{
            type:String,
            default:'map'
        },
        timeRange:{
            type:Object
        },
        simpleName:{
            type:String
        },
        isplay:{
            type:Boolean
        },
        is2d:{
            type:Boolean
        },
        url: {
          type: String
        },
        collections: {
            type: Array
        },
        productFileList:{
            type: Array
        },
        coordinates: {
            type: String
        },
        legendObj:{
           type:Object
       }
    },
    components:{
    },
    data(){
        return{
            options: [
            ],
            value: '',
            baseMap:null,
            version:0,
            timer:null,
            startTime:'',
            endTime:'',
            nowTime:'',
            TimeLayerGroup:null,
            lalayerIDlist:[],
            mouseLng:0,
            mouseLat:0,
            timeList:[],
            layerIndex: 0,
            isFirst:true,
            urlList:[
                
            ],
            AllCollection:[],
            oldNum:'',
            newNum:''
        }
    },
    watch:{
        
    },
    computed:{
    },
    destroyed(){
        
    },
    methods:{
        
        changeValue(val){
            this.TimeLayerGroup.clearLayers()
            let first = val.split('.')[0]
            tiledMapLayer(this.iserverHeader+this.url+'/'+first,{noWrap:true}).addTo(this.TimeLayerGroup)
        },
        async initMap(){
            let that = this
            let crs  = L.CRS['EPSG'+that.collections[0].baseUnderUrl]
            var url
            if(this.collections[0].baseUnderUrl==='3995'){
                this.baseMap = L.map(this.initId, {
                    crs: L.CRS.NonEarthCRS({
                        bounds: L.bounds([-45888490.52,-47298112.34], [45888490.52, 45888490.52]),
                        origin: L.point(-45888490.52,45888490.52)
                    }),
                    center: [733210.56 , -1230428.86],
                    maxZoom: 18,
                    zoomControl:false,
                    attributionControl:false,
                    zoom: 4,
                });
                
                url = this.iserverHeader+'/iserver/services/map-ImageBaseMap/rest/maps/BG4326_3995'
                tiledMapLayer(url, {
                noWrap: true
                }).addTo(this.baseMap);
            }else{
                if(crs){
                    this.baseMap = L.map(this.initId, {
                        center: [0,0],
                        maxZoom: 18,
                        crs:crs,
                        zoomControl:false,
                        attributionControl:false,
                        zoom: 4,
                    });
                    tiandituTileLayer({
                        layerType: 'img',
                        key: '73ae12883e85f0abe62f8941835a4129'
                    }).addTo(this.baseMap);
                    if (!this.isEnglish) {
                        tiandituTileLayer({
                            layerType: 'img',
                            isLabel: true,
                            key: '73ae12883e85f0abe62f8941835a4129',
                            noWrap: false,
                        }).addTo(this.baseMap);
                        }else{
                        tiandituTileLayer({
                            url: 'http://t0.tianditu.gov.cn/eia_c/wmts?&layer=eia&',
                            layerType: 'img',
                            isLabel: true,
                            key: '73ae12883e85f0abe62f8941835a4129',
                            noWrap: false,
                        }).addTo(this.baseMap);
                    }
                }else{
                    this.baseMap = L.map(this.initId, {
                        center: [0,0],
                        maxZoom: 18,
                        zoomControl:false,
                        attributionControl:false,
                        zoom: 4,
                    });
                    url = initmapUlr+this.collections[0].underPaintingUrl
                    tiledMapLayer(url,{
                        noWrap:true
                    }).addTo(this.baseMap);
                }
            }
            this.baseMap.on('mousemove',function(e){
                // that.mouseLat = e.latlng.lat
                // that.mouseLng = e.latlng.lng
                that.mouseLat = e.latlng.lat.toFixed(6)
                that.mouseLng = e.latlng.lng.toFixed(6)
            })
            this.TimeLayerGroup = L.layerGroup().addTo(this.baseMap);
            try {
                this.getLIST()
            } catch (error) {
                console.log(error);
            }
        },
        addOne(){
            let that = this
            const rootUrl = this.urlList.shift()
            let b = tiledMapLayer(rootUrl,{noWrap:true})
            b.addTo(this.TimeLayerGroup)
            that.lalayerIDlist.push(b._leaflet_id)
            this.urlList.push(rootUrl)
        },
        getLIST2(){
            let that = this
            const startTime = that.timeRange.start + ' 00:00:00'
            const endTime = that.timeRange.end + ' 23:59:59'
            let param = {
                productId:that.simpleName,
                startTime:startTime,
                endTime:endTime
            }
            getImageShowList(param).then(res =>{
                that.options = res.data
                let first
                if(that.options.length>0){
                    first = that.options[0].pngUrl.split('/').pop().split('.')[0]
                    this.value = that.options[0].time
                    tiledMapLayer(that.iserverHeader+that.url+'/'+first,{noWrap:true}).addTo(this.TimeLayerGroup)
                }
            })
        },
        getLIST(){
            this.options = this.productFileList
            let first = this.options[0].fileName.split('.')[0]
            this.value = this.options[0].fileCreateTime
            tiledMapLayer(this.iserverHeader+this.url+'/'+first,{noWrap:true}).addTo(this.TimeLayerGroup)
            let bounds = JSON.parse(this.coordinates)
            console.log(bounds);
            this.baseMap.fitBounds([
                [bounds[1], bounds[0]],
                [bounds[3], bounds[2]]
            ]);
        }
    },

    created(){
        this.urlList = [
        ]
    },
    mounted(){
        this.initMap()
    }
}
</script>

<style lang="scss" scoped>
/deep/ .xixi{
  .el-input__inner{
    color: black;
  }
}
.changeMap{
    position: absolute;
    right: 8px;
    bottom: 24px;
    z-index: 100000;
}
.map{
    width: 100%;
    height: 100%;
    .loction{
        position: absolute;
        left: 12px;
        top: 0px;
        z-index: 100000;
        color: white;
        height: 29px;
        padding: 0 12px;
        background-image: url("../../../assets/image/product-detail-dialog/矩形 3 拷贝.png");
        background-size: 100% 100%;
    }
    .legend-my{
        position: absolute;
        left: 0;
        bottom: 6px;
        padding-left: 12px;
        z-index: 100000;
        .right{
            position: absolute;
            left: 36px;
            top: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 160px;
            p{
                width: 47px;
                display: inline;
            }
        }
        .legend-show{
            width: 24px;
            height: 160px;
        }
    }
    .time-step{
        position: absolute;
        left: 260px;
        bottom: 10px;
        z-index: 100000;
    }
}
/deep/.iclient-leaflet-logo{
    display: none;
}
</style>
